import { render, staticRenderFns } from "./Lot_Details.vue?vue&type=template&id=764d8b96&"
import script from "./Lot_Details.vue?vue&type=script&lang=js&"
export * from "./Lot_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports